import React, { useEffect, useState } from "react";
import LivePng from "../../../../assets/images/iconFan/Group850.png";
import FanGroupNav from "../../../../Screen/SuperStar/FanGroup/Content/FanGroupNav";
import AllModuleData from "../../../Reuseable/AllModuleData";
import HomeFanLive from "./Content/HomeFanLive";
import { Link } from "react-router-dom";
import axios from "axios";
import LoaderPost from "../../../Reuseable/LoaderPost";

const FanGroupHome = () => {
  const [event_data, setLiveFan] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/star/fan/group/starlist/status").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setLiveFan(res.data.starLiveGroup);
      }
    });
  }, []);

  return (
    <>
      <FanGroupNav />

      <div className="card card-bg head-line mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <img
              width="38px"
              className="img-fluid text-white pt-2"
              src={LivePng}
              alt=""
            />
          </div>
          <h4 className="mx-3 text-white p-2">
            <span className="livechat-card-small">Live Fan Group</span>
          </h4>
        </div>
      </div>
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar/fan-group-live`}
        />
      )}
    </>
  );
};

export default FanGroupHome;
